import { AdminLocationForm, AdminLocationFormValue, StatusOption } from "@/features/admin/location-form"
import { TimeZoneOption } from "@/lib/time-zone"
import { AdminLayout } from "@/components/layouts/admin-layout"
import { MainContainer } from "@/components/ui/container"
import { PageHeader } from "@/components/ui/headers"
import { t } from "@/lib/i18n"

type Props = {
  location: AdminLocationFormValue
  statusOptions: StatusOption[]
  timezones: TimeZoneOption[]
  errors?: Record<string, string | string[]>
}

export default function AdminLocationsNew({ location, statusOptions, timezones, errors }: Props) {
  return (
    <AdminLayout>
      <MainContainer size="md">
        <PageHeader
          title={t("ui.react.pages.admin.locations.new.title")}
          description={t("ui.react.pages.admin.locations.new.description")}
        />
        <AdminLocationForm
          location={location}
          statusOptions={statusOptions}
          timezones={timezones}
          action="/locations"
          method="post"
          title={t("ui.react.pages.admin.locations.new.title")}
          errors={errors}
        />
      </MainContainer>
    </AdminLayout>
  )
}
